
import { mapMutations } from 'vuex'
import { TEMPLATE_JOB_ID } from '@/utils/jobs'

export default {
  name: 'JobApplyButton',
  props: {
    jobId: {
      type: [Number, String],
      default: TEMPLATE_JOB_ID,
      required: false,
    },
    jobTitle: {
      type: String,
      required: false,
      default: 'Send us your CV',
    },
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  methods: {
    ...mapMutations('behaviour', {
      hideJobApplicationModal: 'hideJobApplicationModal',
      showJobApplicationModal: 'showJobApplicationModal',
    }),
    showModal() {
      this.showJobApplicationModal()
      this.isModalVisible = true
    },
    hideModal() {
      this.hideJobApplicationModal()
      this.isModalVisible = false
    },
  },
}
